import { STEP_LABELS } from "@/store/portal-store";
import { cn } from "@/lib/utils";

interface ProgressIndicatorProps {
  currentStep: number;
}

export function ProgressIndicator({ currentStep }: ProgressIndicatorProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b px-4 py-3 safe-area-top">
      <div className="flex items-center justify-between max-w-md mx-auto">
        {STEP_LABELS.map((label, i) => {
          const step = i + 1;
          const isCompleted = step < currentStep;
          const isCurrent = step === currentStep;
          const isFuture = step > currentStep;

          return (
            <div key={label} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "w-3 h-3 rounded-full transition-all",
                    isCompleted && "bg-green-500",
                    isCurrent && "bg-blue-500 animate-pulse",
                    isFuture && "border-2 border-gray-300 bg-white"
                  )}
                />
                {isCurrent && (
                  <span className="text-[9px] text-blue-600 font-medium mt-1 absolute top-10 whitespace-nowrap">
                    {label}
                  </span>
                )}
              </div>
              {i < STEP_LABELS.length - 1 && (
                <div
                  className={cn(
                    "w-4 h-0.5 mx-0.5",
                    step < currentStep ? "bg-green-500" : "bg-gray-200"
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
